import { useNavigate } from 'react-router-dom';
import { Button } from '@bbpos/ui';
import { posUrl } from '@/lib/pos-url';

export function QuickActionsBar() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-wrap items-center gap-3">
      <Button
        variant="secondary"
        size="sm"
        onClick={() => navigate('/reports')}
        icon={
          <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        }
      >
        View All Reports
      </Button>
      <button
        onClick={() => {
          window.open(posUrl('/pos/billing'), '_blank');
        }}
        className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-gradient-to-r from-brand-500 to-indigo-500 text-white text-sm font-medium shadow-md shadow-brand-500/25 hover:shadow-lg hover:shadow-brand-500/30 transition-all duration-200 hover:-translate-y-0.5"
      >
        <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
        Go to POS
      </button>
    </div>
  );
}
